import DadosBancarios from './dadosBancarios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    handleChangeDadosBanco,
    listDadosBancoAction,
    changeDadosIniciaisDadosBancariosValueForm,
    handleChangeDadosTipoConta,
    listTipoContaAction
} from '../../store/dadosBancarios/actions';

const mapStateToProps = (state, nextState) => ({
  dadosBancarios: state.dadosBancarioReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    handleChangeDadosBanco,
    listDadosBancoAction,
    changeDadosIniciaisDadosBancariosValueForm,
    handleChangeDadosTipoConta,
    listTipoContaAction
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DadosBancarios);